export const plantDockDefaultValues = (plantId: number) => ({
  Id: 0,
  Code: "",
  Name: "",

  NumberOfTrucks: 0,
  PerDefinedTime: "00:00",

  PlantId: plantId,

  IsNewDock: true,
});
